const vScrollBottom = (app)=>{
    app.directive('scroll-bottom', {
        beforeMount(el, binding) {
            const callback = binding.value
            
            const handleScroll = () => {
            const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1
            if (isBottom) callback()
            }
            
            el.addEventListener('scroll', handleScroll)
            
            // 保存引用以便移除
            el._scrollHandler = handleScroll
        },
        unmounted(el) {
            el.removeEventListener('scroll', el._scrollHandler)
        }
    })
}

export {
    vScrollBottom
}